import moment from 'moment';
import {Injectable, signal} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppConfig} from '../../app.config';
import {map} from 'rxjs/operators';
moment.locale('de');

@Injectable()
export class EventsService {
  countryId = signal('');
  citiesId = signal([]);
  organizationsId = signal([]);
  targetGroups = signal([]);
  eventTypes = signal([]);
  eventRegistration = signal<number | string>('');
  milestone = signal<number | string>('');
  publicEvents = signal<number | string>('');
  migrate = signal<number | string>('');
  myEvents = signal<number | string>('');

  constructor (private http: HttpClient , private api: AppConfig) {

  }

  getEvents(page = 1, perPage = 50, sort = 'name', direction = 'ASC', search = '', showOld = false, running = false,
               deleted = false, platformId = '') {
    return this.http.get(this.api.baseUrl + '/event/eventsV2?countryId=' + this.countryId() +
      '&citiesId=' + this.citiesId().toString() + '&targetGroupsId=' + this.targetGroups().toString() + '&eventTypesId=' + this.eventTypes().toString() +
      '&organizationsId=' + this.organizationsId().toString() + '&public=' + this.publicEvents() + '&registration=' + this.eventRegistration() +
      '&milestone=' + this.milestone() + '&migrate=' + this.migrate() + '&myEvents=' + this.myEvents() +
      '&page=' + page + '&perPage=' + perPage + '&sort=' + sort + '&direction=' + direction + '&search=' + search +
      '&showOld=' + showOld + '&running=' + running + '&platformId=' + platformId + '&deleted=' + deleted, this.api.jsonTokenHeaders);
  }

  eventsForCalendarV2(page = 1, perPage = 50, sort = 'name', direction = 'ASC', search = '', showOld = false, running = false,
               deleted = false, platformId = '') {
    return this.http.get(this.api.baseUrl + '/event/eventsForCalendarV2?countryId=' + this.countryId() +
      '&citiesId=' + this.citiesId().toString() + '&targetGroupsId=' + this.targetGroups().toString() + '&eventTypesId=' + this.eventTypes().toString() +
      '&organizationsId=' + this.organizationsId().toString() + '&public=' + this.publicEvents() + '&registration=' + this.eventRegistration() +
      '&milestone=' + this.milestone() + '&migrate=' + this.migrate() + '&myEvents=' + this.myEvents() +
      '&page=' + page + '&perPage=' + perPage + '&sort=' + sort + '&direction=' + direction + '&search=' + search +
      '&showOld=' + showOld + '&running=' + running + '&platformId=' + platformId + '&deleted=' + deleted, this.api.jsonTokenHeaders);
  }

  setCountryId (id: any) {
    this.countryId.set(id);
    this.citiesId.set([]);
    this.organizationsId.set([]);
  }

  setCities (city: any) {
    this.citiesId.update(prevCities => {
      let updatedCities = [...prevCities];
      if (Array.isArray(city.canton)) {
        updatedCities = city.canton;
      } else {
        if (city.selected) {
          updatedCities.push(city.canton);
        } else {
          updatedCities = updatedCities.filter(id => id !== city.canton);
        }
      }
      return [...new Set(updatedCities)];
    });
  }

  getCities () {
    return this.citiesId();
  }

  setOrganizations (organization: any) {
    this.organizationsId.update(prevOrganizations => {
      let updatedOrganizations = [...prevOrganizations];
      if (Array.isArray(organization.organization)) {
        updatedOrganizations = organization.organization;
      } else {
        if (organization.selected) {
          updatedOrganizations.push(organization.organization);
        } else {
          updatedOrganizations = updatedOrganizations.filter(id => id !== organization.organization);
        }
      }
      return [...new Set(updatedOrganizations)];
    });
  }

  getOrganizations () {
    return this.organizationsId();
  }


  setTargetGroups (targetGroup: any) {
    this.targetGroups.update(prevTargetGroups => {
      let updatedTargetGroups = [...prevTargetGroups];
      if (Array.isArray(targetGroup.targetGroups)) {
        updatedTargetGroups = targetGroup.targetGroups;
      } else {
        if (targetGroup.selected) {
          updatedTargetGroups.push(targetGroup.targetGroups);
        } else {
          updatedTargetGroups = updatedTargetGroups.filter(id => id !== targetGroup.targetGroups);
        }
      }
      return [...new Set(updatedTargetGroups)];
    });
  }

  getTargetGroups () {
    return this.targetGroups();
  }

  setEventTypes (eventType: any) {
    this.eventTypes.update(prevEventTypes => {
      let updatedEventTypes = [...prevEventTypes];
      if (Array.isArray(eventType.eventType)) {
        updatedEventTypes = eventType.eventType;
      } else {
        if (eventType.selected) {
          updatedEventTypes.push(eventType.eventType);
        } else {
          updatedEventTypes = updatedEventTypes.filter(id => id !== eventType.eventType);
        }
      }
      return [...new Set(updatedEventTypes)];
    });
  }

  getEventTypes () {
    return this.eventTypes();
  }

  setMilestone (milestone: any) {
    if (milestone) {
      this.milestone.set(1);
    } else {
      this.milestone.set('');
    }
  }

  setMyEvents (myEvents: any) {
    if (myEvents) {
      this.myEvents.set(1);
    } else {
      this.myEvents.set('');
    }
  }

  setPublic (publicData: any) {
    this.publicEvents.set(publicData);
  }

  setRegistration(registrationData: any) {
    if (registrationData) {
      this.eventRegistration.set(1);
    } else {
      this.eventRegistration.set('');
    }
  }

  setToAll () {
    this.countryId.set('');
    this.citiesId.set([]);
    this.organizationsId.set([]);
    this.targetGroups.set([]);
    this.eventTypes.set([]);
    this.eventRegistration.set('');
    this.milestone.set('');
    this.publicEvents.set('');
    this.migrate.set('');
    this.myEvents.set('');
  }

  getOrganizationByCantons () {
    return this.http.get(this.api.baseUrl + '/organization/organizationByCantons?cantons=' + this.citiesId().toString() , this.api.jsonTokenHeaders);
  }

  getCountry () {
    return this.http.get(this.api.baseUrl + '/country/countries' , this.api.jsonTokenHeaders);
  }

  getCity (id) {
    return this.http.get(this.api.baseUrl + '/city/cityByCountry?id=' + id , this.api.jsonTokenHeaders);
  }

  getOrganizationByCity (id) {
    return this.http.get(this.api.baseUrl + '/organization/organizationByCity?id=' + id , this.api.jsonTokenHeaders);
  }

  getEventType() {
    return this.http.get(this.api.baseUrl + '/eventType/eventTypes'  , this.api.jsonTokenHeaders);
  }

  getUserByOrganization (id) {
    return this.http.get(this.api.baseUrl + '/user/userByOrganisation?id=' + id , this.api.jsonTokenHeaders);
  }

  targetGroupsGroped(withSettings = true) {
    return this.http.get(this.api.baseUrl + '/targetGroup/targetGroupsGroped?withSettings=' + withSettings , this.api.jsonTokenHeaders);
  }

  getLevels() {
    return this.http.get(this.api.baseUrl + '/eventLevel/eventLevels', this.api.jsonTokenHeaders);
  }

  getTagByOrganization (id) {
    return this.http.get(this.api.baseUrl + '/tag/tagsByOrganization?id=' + id , this.api.jsonTokenHeaders);
  }

  getEventForRecommendation(page = 1, perPage = 50, search) {
    return this.http.get(this.api.baseUrl + '/event/eventsForRecommendation?search=' + search + '&page=' +
      page + '&perPage=' + perPage, this.api.jsonTokenHeaders);
  }

  addRecommendation(data) {
    return this.http.post(this.api.baseUrl + '/recommendation/addRecommendation', data, this.api.jsonTokenHeaders);
  }

  removeRecommendation(id) {
    return this.http.get(this.api.baseUrl + '/recommendation/removeRecommendation?id=' + id, this.api.jsonTokenHeaders);
  }

  getFileStream(name) {
    if (name) {
      return this.api.baseUrl + '/event/getEventFilesStream/' + name;
    } else {
      return '';
    }
  }

  saveEvent(data) {
    return this.http.post(this.api.baseUrl + '/event/saveEvent', data, this.api.jsonTokenHeaders);
  }

  saveEventPicture(eventId: number, file: File) {
    const formData: FormData = new FormData();
    formData.append('eventId', eventId.toString());
    formData.append('file', file);
    return this.http.post(this.api.baseUrl + '/event/saveEventPicture', formData, this.api.formDataHeaders);
  }

  saveSubEvents(data) {
    return this.http.post(this.api.baseUrl + '/event/saveSubEvents', data, this.api.jsonTokenHeaders);
  }

  saveSubEventPicture(id: number, file: File) {
    const formData: FormData = new FormData();
    formData.append('subEventId', id.toString());
    formData.append('file', file);
    return this.http.post(this.api.baseUrl + '/event/saveSubEventPicture', formData, this.api.formDataHeaders);
  }

  getEvent(id) {
    return this.http.get(this.api.baseUrl + '/event/event/' + id , this.api.jsonTokenHeaders).pipe(
      map((event: any) => {
        if (event.eventDates) {
          event.dates = event.eventDates.map(d => ({
            ...d,
            date: new Date(d.date),
            startTime: this.parseTimeToDate(d.startTime),
            endTime: this.parseTimeToDate(d.endTime)
          }));
        } else {
          event.dates = [];
        }
        if (event.subEventsData) {
          event.subEventsData = event.subEventsData.map(sub => ({
            ...sub,
            date: new Date(sub.date),
            fromTime: this.parseTimeToDate(sub.fromTime),
            toTime: this.parseTimeToDate(sub.toTime)
          }));
        }
        if (event.dateVisibleFrom) {
          event.dateVisibleFrom = new Date(event.dateVisibleFrom);
        }
        if (event.dateVisibleTo) {
          event.dateVisibleTo = new Date(event.dateVisibleTo);
        }
        if (event.endOfReservation) {
          event.endOfReservation = new Date(event.endOfReservation);
          if (event.endOfReservation > new Date()) {
            event.reserve = true;
          }
        }
        if (event.registrationEnd) {
          event.registrationEnd = new Date(event.registrationEnd);
        }
        if (event.registrationStart) {
          event.registrationStart = new Date(event.registrationStart);
        }
        if (event.weblinks) {
          event.weblinks = event.weblinks.split(',');
        }
        if (!event.minSubEventsCount) {
          event.minSubEventsCount = 0;
        }
        return event;
      })
    );
  }

  private parseTimeToDate(timeString: string): Date {
    if (!timeString) {
      return null;
    }
    const d = new Date();
    const [hours, minutes] = timeString.split(':');
    d.setHours(+hours, +minutes, 0, 0);
    return d;
  }

  subscriptionToEvent(body) {
    return this.http.post(this.api.baseUrl + '/subscription/addSubscription', body, this.api.formDataHeaders);
  }

  unSubscriptionToEvent(id) {
    return this.http.get(this.api.baseUrl + '/subscription/deleteSubscription?id=' + id, this.api.jsonTokenHeaders);
  }

  getQrcodeFree(eventId, number) {
    return this.http.get(this.api.baseUrl + '/code/qrCodesFree?eventId=' + eventId + '&number=' + number, this.api.jsonTokenHeaders);
  }

  deleteEvent(id) {
    return this.http.get(this.api.baseUrl + '/event/deleteEvent?id=' + id, this.api.jsonTokenHeaders);
  }

  reactivateEvent(id) {
    return this.http.get(this.api.baseUrl + '/event/reactivateEvent?id=' + id, this.api.jsonTokenHeaders);
  }

  getParticipants(eventId) {
    return this.http.get(this.api.baseUrl + '/participant/participants?id=' + eventId, this.api.jsonTokenHeaders);
  }

  getSubEventForBooking(eventId) {
    return this.http.get(this.api.baseUrl + '/subEvent/subEventForBooking?eventId=' + eventId, this.api.jsonTokenHeaders);
  }

  getSubscribers(id) {
    return this.http.get(this.api.baseUrl + '/subscription/subscriptionsByEvent?id=' + id, this.api.jsonTokenHeaders);
  }

  editNumberOfSeats(body) {
    return this.http.post(this.api.baseUrl + '/subscription/editNumberOfSeats', body, this.api.formDataHeaders);
  }

  addSkills(body) {
    return this.http.post(this.api.baseUrl + '/front-user-skill/createFromEvent', body, this.api.formDataHeaders);
  }

  reserveSubscriptionToEvent(data, id         ) {
    return this.http.get(this.api.baseUrl + '/subscription/reseveSubscriptionToEvent?count=' + data + '&eventId=' + id, this.api.formDataHeaders);
  }
}

